import { Link, Flex } from "@evergis/ui";
import styled from "styled-components";

export const PublicLink = styled(Link)`
  font-size: 0.75rem;
`;

export const PublicLinkPanel = styled(Flex)`
  max-width: 35rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  background-color: ${({ theme: { palette } }) => palette.background};
  flex-direction: column;
`;

export const LinkPanelRow = styled(Flex)`
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
`;

export const PublicLinkPanelControls = styled(Flex)`
  flex-shrink: 0;
`;

export const PublicLinkTextControls = styled(Flex)`
  border: 1px dashed rgba(0, 0, 0, 0.12);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 1px;
  padding-left: 0.5rem;
  margin-right: 0.5rem;
  height: 2rem;
  box-sizing: border-box;
`;

export const LinkText = styled.div`
  font-size: 1rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

export const LinkDescription = styled.span`
  font-size: 12px;
  color: ${({ theme: { palette } }) => palette.primary};
`;

export const ExternalLink = styled(Link)`
  margin-bottom: 0.5rem;
`;
